import { environment } from './../environments/environment';

export const API_NODE_CERT_VAL = environment.api_node_cert_val;
export const API_JAVA_AUTH = environment.api_java_auth;
export const API_JAVA_CONSULTA_MAQUINA = environment.api_java_consulta_maquina;
export const API_JAVA_CONSULTA_HISTORICO_MAQUINA = environment.api_java_historico_maquina;
export const API_JAVA_CADASTRA_MAQUINA = environment.api_java_cadastra_maquina;
export const API_JAVA_ALTERA_ESTADO_MAQUINA = environment.api_java_altera_estado_maquina
export const API_JAVA_ALTERA_MAQUINA = environment.api_java_altera_maquina

export const API_NODE_OBTER_PERFIL = environment.api_node_obter_perfil;
export const API_NODE_CERT_BLOQ = environment.api_node_cert_bloq;
export const API_NODE_DADOS_OUTORGANTE = environment.api_node_dados_outorgante;
export const API_NODE_SERV_OUTORGA = environment.api_node_serv_outorga;
export const API_NODE_CERT_SITUACAO = environment.api_node_cert_situacao;

export const API_CNS_PORTAL = environment.api_cns_portal;

export const MANUAL_CNS = environment.manual_cns;


export const API_DOWNLOAD_KRYPTONITA = environment.api_download_kriptonita;

